import { fork, all } from 'redux-saga/effects';
import watchForCoreSagas from 'domains/core/sagas';
import watchForCommonSagas from 'domains/common/sagas';

export default function* root() {
  yield all([fork(watchForCoreSagas), fork(watchForCommonSagas)]);
}
